export default [
    {
        path: '/admin/productos',
        name: 'admin.productos',
        meta: { nombre: 'Productos' },
        component: () => import('../../pages/productos/admin/index').then(m => m.default || m)
    }
]
